export class AppSettings {
    static StorageKeys = class {
        public static Token = 'token';
        public static User: any = 'user';
        public static TimeConfig: any = 'time-config';
        public static ClientConfig: any = 'client-config';
        public static FinalApproval: any = 'final-approval';
        public static DomainDetails: any = 'domain-details';
        public static MessageCount: any = 'message-count';
        public static Menu: any = 'menu';
        public static IsFixedAssetMenu: any = 'fixed-asset';
        public static FixedAssetMenu: any = 'fixed-asset-menu'; 
        public static MobileRecentMenu: any = 'mobile-recent-menu';
        public static MobileMenuSearch: any = 'mobile-menu-search';
        public static ClarityProjectId: any = 'clarity-project-id';
    }
}